import { IconComponentsProps } from './types';

const ArrowNextIcon = ({ fill = '#1010EB', ...props }: IconComponentsProps) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 6.94141L16.5 12.9414L9 18.9414V6.94141Z" fill={fill} />
  </svg>
);

export default ArrowNextIcon;
